export default __webpack_public_path__ + "0e4ea51b20068d1ec7bd7dc25e65a9ff.png";